export default "__VITE_ASSET__8x$Ff28X__"